import React from "react";
import Footer6 from "../Footer6";
import "./Footer5.css";

function Footer5() {
  return (
    <div className="footer-9">
      <Footer6 />
    </div>
  );
}

export default Footer5;
